import { render } from "./user-top-profile.vue?vue&type=template&id=4456d277&ts=true"
import script from "./user-top-profile.vue?vue&type=script&lang=ts"
export * from "./user-top-profile.vue?vue&type=script&lang=ts"

import "./user-top-profile.vue?vue&type=style&index=0&id=4456d277&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__